import {LocalApiErrorCode} from '../shared/errors/local-api-error-code';

export const authLocalErrorCodes: Readonly<Record<string, readonly LocalApiErrorCode[]>> = {
  '/v1/auth/login': ['VALIDATION_ERROR', 'EmailConfirmationRequired', 'InactiveUser'],
  '/v1/auth/google': ['VALIDATION_ERROR', 'ExternalIdentityConflict', 'InactiveUser'],
  '/v1/auth/register': ['VALIDATION_ERROR', 'UserEmailAlreadyExists', 'UserEmailAlreadyExistsInactive', 'UsernameAlreadyExists'],
  '/v1/auth/verify-email': ['VALIDATION_ERROR', 'BadRequest'],
  '/v1/auth/forgot-password': ['VALIDATION_ERROR'],
  '/v1/auth/reset-password': ['VALIDATION_ERROR', 'BadRequest'],
};
